import { FieldTypes, type QuestionData } from '@playbooks/action-cards-utils/src'

import { useTranslation } from '../contexts/localization/Localization'
import { parseDate } from './utils'

/**
 * Get the answer provided by the user to the given Action Card question.
 * @param question Question to find the answer to
 * @param translation Translator function
 * @returns Answer as string
 */
export default function getAnswer(
  question: QuestionData,
  translation: ReturnType<typeof useTranslation>['text'],
  useBrackets: boolean,
) {
  const text = useBrackets ? `(${question.text})` : `${question.text}`

  switch (question.type) {
    case FieldTypes.Dropdown: {
      const answer = (question.data as { id: number; name: string }[]).find(item => item.id === question.value)
      return dangerousTagsHandler(answer?.name || text, question.text)
    }

    case FieldTypes.Checkbox: {
      return dangerousTagsHandler(question?.value ? translation('yes') : translation('no'), question?.text)
    }

    case FieldTypes.LongText: {
      return dangerousTagsHandler((question?.value as string)?.replaceAll('\n', '<br />') || text, question?.text)
    }

    case FieldTypes.Date: {
      return dangerousTagsHandler(parseDate(question?.value as string)?.toLocaleDateString() ?? text, question?.text)
    }

    case FieldTypes.DateTime: {
      return dangerousTagsHandler(parseDate(question?.value as string)?.toLocaleString() ?? text, question?.text)
    }

    default:
      return dangerousTagsHandler(question?.value?.toString?.() || text || question?.type, question?.text)
  }
}

function dangerousTagsHandler(value: string, fieldName: string): string {
  const tags = [
    '<applet',
    '<style',
    '<link',
    '<iframe',
    '<script',
    '<img',
    '<video',
    '<comment',
    '<embed',
    '<link',
    '<listing',
    '<meta',
    '<noscript',
    '<object',
    '<plaintext',
    '<script',
    '<xmp',
    'onmouseover=',
    'onerror=',
  ]

  for (const tag of tags) {
    if (value.includes(tag))
      return `<p style="color: red !important">The "${fieldName}" field has dangerous tags or attributes. Check it out.</p>`
  }

  return value
}
